// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-alert[data-v-31777feb] {\n  color: white;\n}[dir] .bg-alert[data-v-31777feb] {\n  background: #a46cbd;\n  border-radius: 5px;\n}\n\n", ""]);
// Exports
module.exports = exports;
